/** Calendar date in the given locale, using the browser timezone, with no hour. */
export const formatCalendarDate = (iso: string, locale?: string): string => {
  const date = new Date(iso)
  return locale ? date.toLocaleDateString(locale) : date.toLocaleDateString()
}

/**
 * The hour in `timeZone`, spelled in `spellLocale`, then the IANA name.
 * Blank when the timezone is missing or cannot be used.
 */
export const formatHourInTimezone = (
  iso: string,
  timeZone: string | null | undefined,
  spellLocale?: string,
): string => {
  if (!timeZone) return ''
  try {
    const hour = new Intl.DateTimeFormat(spellLocale || undefined, {
      timeZone,
      hour: 'numeric',
    }).format(new Date(iso))
    return `${hour} ${timeZone}`
  } catch {
    return ''
  }
}
